import Link from "next/link";
const destinations = [{
  name: "Maui, HI",
  path: "/vacation-rentals/Maui--Hawaii--USA"
}, {
  name: "Destin, FL",
  path: "/vacation-rentals/Destin--Florida--USA"
}, {
  name: "San Diego, CA",
  path: "/vacation-rentals/San-Diego--California--USA"
}, {
  name: "Seattle, WA",
  path: "/vacation-rentals/Seattle--Washington--USA"
}, {
  name: "Orlando, FL",
  path: "/vacation-rentals/Orlando--Florida--USA"
}, {
  name: "Los Angeles, CA",
  path: "/vacation-rentals/Los-Angeles--California--USA"
}, {
  name: "Gatlinburg, TN",
  path: "/vacation-rentals/Gatlinburg--Tennessee--USA"
}, {
  name: "Gulf Shores, AL",
  path: "/vacation-rentals/Gulf-Shores--Alabama--USA"
}, {
  name: "Kissimmee, FL",
  path: "/vacation-rentals/Kissimmee--Florida--USA"
}, {
  name: "Myrtle Beach, SC",
  path: "/vacation-rentals/Myrtle-Beach--South-Carolina--USA"
}, {
  name: "Ocean City, MD",
  path: "/vacation-rentals/Ocean-City--Maryland--USA"
}, {
  name: "New Orleans, LA",
  path: "/vacation-rentals/New-Orleans--Louisiana--USA"
}, {
  name: "Austin, TX",
  path: "/vacation-rentals/Austin--Texas--USA"
}, {
  name: "Nashville, TN",
  path: "/vacation-rentals/Nashville--Tennessee--USA"
}, {
  name: "Cabo San Lucas, MX",
  path: "/vacation-rentals/Cabo-San-Lucas--Mexico"
}, {
  name: "Atlanta, GA",
  path: "/vacation-rentals/Atlanta--Georgia--USA"
}, {
  name: "London, UK",
  path: "/vacation-rentals/London--England--UK"
}, {
  name: "Palm Springs, CA",
  path: "/vacation-rentals/Palm-Springs--California--USA"
}, {
  name: "Denver, CO",
  path: "/vacation-rentals/Denver--Colorado--USA"
}, {
  name: "Tuscany, IT",
  path: "/vacation-rentals/Tuscany--Italy"
}];
const Destinations = () => {
  return <div className='w-full' data-sentry-component="Destinations" data-sentry-source-file="Destinations.tsx">
      <h3 className='mb-5 text-base font-semibold leading-[1.5em] text-white'>
        Top Destinations
      </h3>
      <div className='grid grid-cols-2 gap-x-10 gap-y-[7px] lg:grid-cols-3'>
        {destinations.map(item => <Link key={item.path} href={item.path} className='text-sm leading-[1.375em] text-white hover:text-white/80'>
            {item.name}
          </Link>)}
      </div>
    </div>;
};
export default Destinations;